export const mapCmpObjectData = contentObject => {
  var _contentObject$proper, _contentObject$proper2, _contentObject$proper3, _contentObject$proper4;
  return {
    id: contentObject.objectId,
    name: (_contentObject$proper = (_contentObject$proper2 = contentObject.properties.hs_name) === null || _contentObject$proper2 === void 0 ? void 0 : _contentObject$proper2.value) !== null && _contentObject$proper !== void 0 ? _contentObject$proper : '',
    imgSrc: (_contentObject$proper3 = (_contentObject$proper4 = contentObject.properties.hs_screenshot_preview_url) === null || _contentObject$proper4 === void 0 ? void 0 : _contentObject$proper4.value) !== null && _contentObject$proper3 !== void 0 ? _contentObject$proper3 : ''
  };
};
export const notHasProperty = property => ({
  operator: 'NOT_HAS_PROPERTY',
  property
});
export const propertyNotEquals = (property, value) => ({
  operator: 'NEQ',
  property,
  value
});